import {SaveOutlined} from '@ant-design/icons'
import {Button, Col, Flex, Modal, Row} from 'antd'
import {FC, ReactNode, useState} from 'react'

interface Props {
    onCancel: () => void
    onDelete?: () => void
    showDelete?: boolean
    children?: ReactNode
}

export const ButtonsPanel: FC<Props> = ({onCancel, showDelete, onDelete, children}) => {
    const [deleteModal, setDeleteModal] = useState(false)

    return <Row>
        <Col span="4"/>
        <Col span="20">
            <Flex style={{marginTop: 20, marginRight: 24, marginLeft: 16}}>
                <Flex gap="middle" justify="flex-start" align="flex-start">
                    <Button type="primary" className="adsp-button" htmlType="submit">
                        <SaveOutlined/> Save
                    </Button>
                    <Button type="primary" className="adsp-button" htmlType="button" danger ghost onClick={onCancel}>
                        Cancel
                    </Button>
                    {children}
                </Flex>
                {showDelete && onDelete && (<Flex flex="content" justify="end" align="end">
                        <Modal open={deleteModal} title="Delete the entity" okText="Yes" cancelText="Cancel"
                               onOk={onDelete} onCancel={() => setDeleteModal(false)}
                        >
                            Are you sure?
                        </Modal>
                        <Button type="primary" className="adsp-button" danger onClick={() => setDeleteModal(true)}>
                            Delete
                        </Button></Flex>
                )}
            </Flex>
        </Col>
    </Row>
}